/**
 * Created by andrey on 15.01.18.
 */

const SocialSender = function () {
    BaseSender.call(this);

    this.batch = {};

    const CONFIGS = [
        // Пользователь не может получать более одного уведомления от приложения за 3 дня
        {
            prefix: "mw",
            sources: [connector.MM],
            maxTimeout: 30
        },

        {
            prefix: "ok",
            sources: [connector.OK, connector.OKBRIDGE],
            maxTimeout: 14
        },

        // Обратите внимание, нельзя отправлять пользователю более 1 уведомления в час (3 в сутки).
        {
            prefix: "vk",
            sources: [connector.VK],
            maxTimeout: 30
        },

        {
            prefix: "in",
            sources: [connector.INSTANT],
            maxTimeout: 10
        },

        {
            prefix: "mb",
            sources: [connector.MOBAGE, connector.SP_MOBAGE],
            maxTimeout: 30
        },

        {
            prefix: "kg",
            sources: [connector.KONGREGATE],
            maxTimeout: 30
        },

        {
            prefix: "dc",
            sources: [connector.DISCORD],
            maxTimeout: 30
        },

        {
            prefix: "cl",
            sources: [connector.CLEVERAPPS],
            maxTimeout: 30
        },

        {
            prefix: "ls",
            sources: [connector.LABSYSTECH],
            maxTimeout: 30
        }
    ];

    this.config = CONFIGS.find((config) => connector.platform.oneOf(config.sources));
    this.sendBatch = connector.utils.accumulate(
        connector.utils.parseInterval("10 seconds"),
        this._sendBatch.bind(this)
    );
};

SocialSender.prototype = Object.create(BaseSender.prototype);
SocialSender.prototype.constructor = SocialSender;

SocialSender.prototype.askPermissions = function (options, callback) {
    if (!this.isPushNotifications()) {
        callback(connector.CODE_SUCCEED, true);
        return;
    }

    connector.notifications.trigger("stream:logs", "prm_want");
    console.log("pushes askPermissions start");

    const touchEvent = cc.sys.capabilities.touches ? "touchend" : "click";
    const firstClick = function () {
        window.parent[SocialSender.POST_MESSAGE]({ initServiceWorker: true }, "*");
        cc.game.canvas.removeEventListener(touchEvent, firstClick);
    };
    cc.game.canvas.addEventListener(touchEvent, firstClick);

    const messageHandler = function (event) {
        if (!event.data.initServiceWorker) {
            return;
        }

        connector.notifications.trigger("stream:logs", "prm_show");

        console.log("pushes askPermissions response", event);

        if (event.data.subscription) {
            this.subscription = event.data.subscription;
            connector.notifications.trigger("stream:logs", "prm_got");
        }

        callback(connector.CODE_SUCCEED, Boolean(this.subscription));

        window.removeEventListener("message", messageHandler);
    }.bind(this);

    window.addEventListener("message", messageHandler, false);
};

SocialSender.prototype._sendBatch = function () {
    if (this.isPushNotifications() && !this.subscription) {
        return;
    }

    const path = `${connector.config.notificationsApiURL}/${connector.config.projectId}/sendBatch`;

    const batch = this.batch;

    const data = {
        userId: `${this.config.prefix}_${connector.platform.getUserID()}`,
        language: connector.info.language,
        batch
    };

    if (this.isPushNotifications()) {
        data.userId = `${this.config.prefix}_${this.subscription.endpoint}`;
        data.keys = this.subscription.keys;
    }

    this.batch = {};

    console.log("Sending batch - ", batch);
    ConnectorRestClient.post(path, data, () => {
        console.log("Success push", batch);
    }, () => {
        console.log("Failure push", batch);
    }, {
        fullPath: true
    });
};

SocialSender.prototype.send = function (info, timeout) {
    if (!this.canSend()) {
        return;
    }

    this.batch[info.id] = Math.floor(timeout / 1000);

    this.sendBatch();

    return true;
};

SocialSender.prototype.cancel = function (info) {
    if (!this.canSend()) {
        return;
    }

    this.batch[info.id] = 0;

    this.sendBatch();
};

SocialSender.prototype.isPushNotifications = function () {
    return connector.platform.oneOf(connector.CLEVERAPPS, connector.LABSYSTECH);
};

SocialSender.prototype.canSend = function () {
    return !connector.platform.withTmpID() || this.isPushNotifications();
};

SocialSender.isAppropriate = function () {
    return connector.platform.oneOf(
        connector.OK,
        connector.OKBRIDGE,
        connector.INSTANT,
        connector.KONGREGATE,
        connector.MOBAGE,
        connector.SP_MOBAGE,
        connector.MM,
        connector.VK,
        connector.DISCORD,
        connector.CLEVERAPPS,
        connector.LABSYSTECH
    );
};

SocialSender.POST_MESSAGE = "postMessage";